const WEB_URL = process.env.NEXT_PUBLIC_SITE_URL

export async function fetchCustomer(id) {
  const url = `${WEB_URL}/api/stripe/customer/${id}`
  const response = await fetch(url)
  const data = await response.json()
  return data
}

export const getBillingPortalUrl = async (customerId, returnUrl) => {
  try {
    const customer = await fetchCustomer(customerId)
    if (customer?.subscriptions?.data?.length > 0) {
      const res = await manageBillingPortal({
        returnURL: returnUrl,
        customer: customerId,
      })

      return res.url
    }
  } catch (error) {
    console.error('Error fetching billing portal URL:', error)
    return null
  }
}

export async function isPanoCustomer(id) {
  const url = `${WEB_URL}/api/stripe/customer/${id}`

  if (!id) {
    return false
  }

  const response = await fetch(url)
  const data = await response.json()

  if (data?.subscriptions?.data?.length > 0) {
    for (const subscription of data?.subscriptions?.data) {
      if (
        subscription.status === 'active' ||
        subscription.status === 'trialing'
      ) {
        return true
      }
    }
  }
  return false
}

export async function createCheckout(payload) {
  const { customer_id, cancelUrl, successUrl, returnUrl, discounts } = payload

  if (!customer_id) {
    throw new Error('Missing customer_id')
  }

  const body = { customer_id }

  if (discounts) {
    body.discounts = discounts
  }

  if (cancelUrl) {
    body.cancelUrl = cancelUrl
  }

  if (successUrl) {
    body.successUrl = successUrl
  }

  if (returnUrl) {
    body.returnUrl = returnUrl
  }

  const url = `${WEB_URL}/api/stripe/checkout/create`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const errorData = await response.json()
    throw new Error(errorData.error || 'Failed to create checkout session')
  }

  const data = await response.json()
  return data
}

export async function fetchPaymentLinks(id) {
  const url = `${WEB_URL}/api/stripe/payment_links/${id}`
  const response = await fetch(url)
  const data = await response.json()
  return data
}

export async function manageBillingPortal(payload) {
  const { returnURL, customer } = payload

  if (!returnURL) {
    throw new Error('Missing returnURL')
  }
  if (!customer) {
    throw new Error('Missing customer')
  }

  const url = `/api/stripe/customer/manage`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ returnURL, customer }),
  })
  const data = await response.json()
  return data
}
